import { Alert, Box, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, Typography, useTheme } from "@mui/material";
import { ChangeEvent, ElementType, useRef, useState } from "react";
import UXPageHeader from "../../../components/froms/UXPageHeader";
import ExcelDialogErrors from "./ExcelDialogErrors";
import useExcelImport from "./import.leads.hooks";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button, ButtonProps, styled } from "@mui/material";
import AutoLayout from "../../../components/AutoLayout";
import RuleIcon from '@mui/icons-material/Rule';
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../../hooks/useAuth";
import { ClaimType, ClaimValue } from "../../common/RenderIf";

const ButtonStyled = styled(Button)<ButtonProps & { component?: ElementType; htmlFor?: string }>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        textAlign: 'center'
    }
}))

type Props = {
    onClose: () => void
}

const ExcelImportMapping = ({ onClose }: Props) => {
    const { user } = useAuth()
    const { fileError, loadWorkbook, unmappedColumns, mapSchema, manualMapField, allColumns, hasUnmapped, errors, hasError, loaded, nextStep, skip } = useExcelImport();
    const [showAll, setShowAll] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [showSelectFile, setShowSelectFile] = useState(false);
    const [unmappedColumnError, setUnmappedColumnError] = useState(false);
    const missingSchemaFields = mapSchema.filter(s => !s.mappedField || showAll);
    const columnsToMap = showAll ? allColumns : unmappedColumns;

    const theme = useTheme();
    const navigate = useNavigate();


    const handleExcelFileImport = async (file: ChangeEvent, onChange: any) => {
        setShowSelectFile(false);
        const { files } = file.target as HTMLInputElement
     
        if (files != null) {
            const errors = loadWorkbook(files);
        }
        else {
            
        }
    }

    const handleNext = () => {
        setShowSelectFile(false);
        setUnmappedColumnError(false)

        if (!loaded) {
            setShowSelectFile(true);
            return;
        }

        if (unmappedColumns.length > 0) {
            setUnmappedColumnError(true)
            return;
        }

        if (!hasError) {
            nextStep()
        }
    }

    const onCancel = () => {
        onClose();
    }

    const clearInput = () => {        
        if (inputRef.current) {
            inputRef.current.value = ''
        }
    }

    const handleSkip = () => {
        skip();
    }

    if (!user) return null;

    const canSkip = (!user.claims.some(roleClaim => roleClaim.value === ClaimValue.ManualImport && roleClaim.claim === ClaimType.LeadImport) || user.isAdmin);



    return (
        <AutoLayout title="Import Leads (Excel)" onNext={handleNext} onCancel={onCancel} onSkip={canSkip ? handleSkip : undefined }>
            {hasError && <Alert severity="error" sx={{ mb: 2 }}>Error: please see below for more details.</Alert>}
            {unmappedColumnError && <Alert severity="error" sx={{ mb: 2 }}>Error: please provide a mapping for all columns</Alert>}
            {showSelectFile && <Alert severity="info">Please select an excel file.</Alert>}

            <Typography variant="caption" sx={{ mt: 5 }}>Please upload the file containing the leads you wish to import.</Typography>
            <Box>
                <ButtonStyled onClick={clearInput} size="small" component='label' variant='contained' htmlFor='account-settings-upload-image' endIcon={<FileUploadIcon />} sx={{ mt: 2, mb: 2 }}>
                    Select Excel File
                    <input
                        hidden
                        type='file'
                        ref={inputRef}
                        
                        onChange={(e) => handleExcelFileImport(e, handleExcelFileImport)}
                        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                        id='account-settings-upload-image'
                    />
                </ButtonStyled>
            </Box>

            {loaded && !fileError && <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                        {hasUnmapped && <RuleIcon sx={{ color: theme.palette.error.main }} />}
                        {!hasUnmapped && <DoneIcon sx={{ color: theme.palette.success.main }} />}
                        <Typography variant="subtitle1" sx={{ mb: 2, mt: 2, ml: 2 }}>{hasUnmapped ? "Unmapped Columns" : "All Columns Mapped"}</Typography>
                    </Box>

                    <FormControlLabel control={<Switch checked={showAll} onChange={() => setShowAll(!showAll)} />} label="All" />
                </Box>

                {!hasError && <Grid container rowGap={2}>
                    {missingSchemaFields.map(schemaCol => <>
                        <Grid xs={6}>{schemaCol.columnName}</Grid>
                        <Grid xs={6}>
                            <FormControl fullWidth size="small">
                                <Select value={schemaCol.mappedField} onChange={(e) => manualMapField(e.target.value as string, schemaCol.columnName)}>
                                    {columnsToMap.map(f => <MenuItem value={f}>{f}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>)}
                </Grid>}
            </Box>}


            <ExcelDialogErrors />
        </AutoLayout>
    )
}

export default ExcelImportMapping;